import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ user: propUser, allowedRoles, children }) => {
  const location = useLocation();

  // Fallback to localStorage if user is not passed as a prop
  const user = propUser || JSON.parse(localStorage.getItem("user"));
  if (!user) return <Navigate to="/signin" replace />;

  // Allow F0612 (admin) to access maintenance panel if they came via the special button
  const isAdminBypass = user.token_no === "F0612" && location.state?.fromAdmin;

  if (!allowedRoles.includes(user.role) && !isAdminBypass) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
